const convertFirebaseTimestampToDate = (timestamp) => {
  if (timestamp?._seconds) {
    return new Date(timestamp._seconds * 1000 + 0);
  }
  return null;
};

export default convertFirebaseTimestampToDate;
